import { Component } from "@angular/core";
import { CdkScrollable } from "@angular/cdk/scrolling";

@Component({
  selector: "app-content-layout",
  // `CdkScrollable` registers the scrolling `.page-content` with the CDK
  // ScrollDispatcher so connected overlays (icon picker, channel/columns
  // popovers, …) reposition with the page instead of sticking to the screen.
  imports: [CdkScrollable],
  templateUrl: "./content-layout.html",
  styleUrl: "./content-layout.scss",
})
export class ContentLayout {}
